import React, { Component } from 'react';
//import EdaImage from '../../assets/Curso_img/box/banner_EDA.png'
import InovacaoImage from '../../assets/lives/Live_Inovacao.jpeg'
import HackerImage from '../../assets/lives/Deep_Web.png'
import LgpdImage from '../../assets/lives/Lgpd.png'
import TogafImage from '../../assets/lives/Togaf.png'
import Simplefooter from '../footer/simplefooter'
import './style.css'

export default class Live extends Component {
  state = {
    notShow: true
  }

  
  render() {
    function onLink(url) {
      window.open(url)
    }

    /**
     * Links da HIT-BRA, bem como seu canal, pois ainda não
     * havia link pronto.
     */

    /**
     * O link 'HitChannel' é do canal da HIT, onde, utilizar esse no lugar de vídeos
     * que ainda não tiverem link:
     * 
     * var HitChannel = "https://www.youtube.com/channel/UCskc38hRobYDyMLzKou6fsQ?view_as=subscriber";
     */
    
    var Inovacao = "https://www.youtube.com/watch?v=7bR-8QFSn7w";
    var Hackerlink = "https://www.youtube.com/watch?v=XOCNF5OybeQ";
    var Lgpdlink = "https://www.youtube.com/watch?v=lCCVNWMXlAg";
    var Togaflink = "https://www.youtube.com/watch?v=apsWJ_0-C64";

    return (
      <div>
        <div className="fullHeight">
          <div className="live-container">
            <div className="title">Assista nossas lives, e lembre-se o conhecimento é o primeiro passo para o sucesso!</div>
            <div className="main-live">
              <div className="main-title">Live HIT-BRA Inovação</div>
              <img src={InovacaoImage} alt="imagem da live" onClick={() => {onLink(Hackerlink)}}/>
              <div className="sub-title">INOVAÇÃO</div>
              <p>Acesse o <b onClick={() => {onLink(Inovacao)}}>link</b> para assistir</p>
              <p>Transmitido no dia 08 de setembro de 2020</p>
            </div>

            <div className="past-live">
              {/* <div className="sub-live">
                <img src={HackerImage} alt="imagem da live" onClick={() => {onLink(Hackerlink)}}/>
                <div className="sub-title">Live HIT-BRA Hacker</div>
                <p>Acesse o <b onClick={() => {onLink(Hackerlink)}}>link</b> para assistir</p>
              </div> */}

              <div className="sub-live">
                <img src={HackerImage} alt="imagem da live" onClick={() => {onLink(Hackerlink)}}/>
                <div className="sub-title">HACKING - DEEP WEB E DARK WEB</div>
                <p>Acesse o <b onClick={() => {onLink(Hackerlink)}}>link</b> para assistir</p>
                <p>Transmitido no dia 02 de junho de 2020</p>
              </div> 

              <div className="sub-live">
                <img src={LgpdImage} alt="imagem da live" onClick={() => {onLink(Lgpdlink)}}/>
                <div className="sub-title">LGPD - Privacidade, Segurança e Arquitetura Corporativa</div>
                <p>Acesse o <b onClick={() => {onLink(Lgpdlink)}}>link</b> para assistir</p>
                <p>Transmitido no dia 27 de abril de 2020</p>
              </div>

              {/* <div className="sub-live">
                <img src={EnterpriseImage } alt="imagem da live" onClick={() => {onLink(Enterpriselink)}}/>
                <div className="sub-title">ENTERPRISE ARCHITECTURE</div>
                <p>Acesse o <b onClick={() => {onLink(Enterpriselink)}}>link</b> para assistir</p>
                <p>Transmitido no dia 20 de março de 2020</p>
              </div> */}

              <div className="sub-live">
                <img src={TogafImage} alt="imagem da live" onClick={() => {onLink(Togaflink)}}/>
                <div className="sub-title">TOGAF ÁGIL - TO BE OR NOT TO BE</div>
                <p>Acesse o <b onClick={() => {onLink(Togaflink)}}>link</b> para assistir</p>
                <p>Transmitido no dia 17 de março de 2020</p>
              </div>
            </div>
          </div>
        </div>
        <div class="contact-simplefooter">
          <div class="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    )
  }

  componentDidMount() {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/live/live.js